export * from './lib/radio-input.component.module';

export { AccredibleRadioGroupOption } from './lib/radio-input.model';
